export const formatSayHelloCourseDropdownOptions = (courses: { name: string; id: number }[] = []) => {
  return courses.map((course) => ({
    label: course?.name,
    value: course?.id,
  }));
};
